import React, { useEffect, useRef, useState } from "react";
import "./AppointmentHistory/Appointments.scss";
import moment from "moment";
import { Link, useHistory, useLocation } from "react-router-dom";
import clearStorage from "./DoctorVideo/PatientInfoData";
import IconButton from "@material-ui/core/IconButton";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import VideoIcon from "../assets/video_call_black_24dp.svg";
import UserDetailIcon from "../assets/person-24px.svg";
import ViewDocumentIcon from "../assets/view-documents.svg";
import ViewPrescriptionIcon from "../assets/view-prescription.svg";
import EditPrescriptionIcon from "../assets/edit-prescription.svg";
import NotAvailble from "../assets/not-available.svg";
import { makeStyles } from "@material-ui/core/styles";
import getAppointmentOptions from "./AppointmentHistory/AppointmentOptions";
import CallModal from "./DoctorDashboard/CallModal";
import TitleSubtitleCard from "./common/Modules/TitleSubtitleCard";
import {
  APPLICABLE_ROLE,
  CONSULTATIONTYPE,
  STATUS,
} from "./DashboardAppointmentsView/Constant";
import {
  ACTION_TYPES,
  APPLICABLE_STATUS,
} from "./DashboardAppointmentsView/Helper/actionsHelper";
import {
  CHECK_IN_PROGRESS_APPOINTMENT_API,
  CHECK_NO_SHOW_STATUS_API,
  END_CONSULTATION_API,
  GET_APPOINTMENT_JOURNEY_API,
  MARK_CHECK_IN_API,
  START_CONSULTATION_API,
} from "./DashboardAppointmentsView/DashboardAppointmentsViewApiHandler/APIConstants";
import { getConsultationTypeDetail } from "./DashboardAppointmentsView/Helper";
import AppointmentJoinModal from "./DoctorDashboard/modal-appointment-join";
import RescheduleModal from "./DoctorDashboard/modal-reschedule";
import CancellationModal from "./DoctorDashboard/modal-cancellation";
import MarkCheckInModal from "./DoctorDashboard/modal-mark-check-in";
import MarkNoShowModal from "./DoctorDashboard/modal-mark-noshow";
import CloseOngoingAppntModal from "./common/CloseOngoingAppntModal";
import ClinicDrawerComponent from "./ClinicComponents/ClinicMyAppointments/ClinicDrawerComponent";
import ViewDetailsModalNew from "./common/ViewDetailsModal";
import DocumentContainer from "./UI Component/DocumentViewer/DocumentCotainer";
import ClinicShareReceiptModal from "./ClinicComponents/ClinicMyAppointments/ClinicShareReceiptModal";
import PEMShareContentPopUp from "./PEM";
import Popup from "./PEM/common/Popup";
import AlertMsgPopup from "./common/AlertMsgPopup";
import afterLoginApiAxios from "../Util/API Calls/afterLogin";
import swal from "sweetalert";
import { USER_TYPE } from "../Util/constants";
import ScheduledAppntModal from "./common/ScheduledAppntModal";
import { LOCALSTORAGEKEY } from "../Util/Helper/localStorageUtils";
import { C2CConsole } from "../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../Util/c2cApiHandler";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: 4,
  },
  disableWithPadding: {
    cursor: "not-allowed !important",
    opacity: 0.65,
    padding: 2,
  },
}));
export default function AppointmentPatientRow({
  appointmentData,
  renderAppointmentType,
  viewAppointment,
  renderConsultationType,
  handleViewDocumentClick,
  editPrescriptionAction,
  rescheduleAppointmentAction,
  cancelAppointmentAction,
  raiseInvoiceAction,
  markNoShowAction,
  handleJoinCallClick,
  currentPage,
  refreshAppointments,
}) {
  const history = useHistory();
  const location = useLocation();
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let user_type = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  let doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  let tokenId = localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);
  // Timer logic =>
  let interval = useRef();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeExceededTooltip, setTimeExceededTooltip] = useState("");
  const [showVideoIcon, setShowVideoIcon] = useState(false);
  const [showCallPatientModal, setShowCallPatientModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showJoinAppointmentModal, setShowJoinAppointmentModal] =
    useState(false);
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const [showRaiseInvoiceModal, setRaiseInvoiceModal] = useState(false);
  const [showMarkNoShowModal, setShowMarkNoShowModal] = useState(false);
  const [showCloseOngoingConsultModal, setShowCloseOngoingConsultModal] =
    useState(false);
  const [showAppointmentScheduledModal, setShowAppointmentScheduledModal] =
    useState(false);
  const [ongoingAppointment, setOngoingAppointment] = useState({});
  const [scheduledAppointment, setScheduledAppointment] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [appointmentForDrawer, setAppointmentForDrawer] = useState({});
  const [slugUrl, setSlugUrl] = useState();
  const [documentShow, setDocumentShow] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [showReceiptModal, setshowReceiptModal] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [showPEMShare, setshowPEMShare] = useState(false);
  const [selectedPatientId, setselectedPatientId] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState();
  const [appointmentJourney, setAppointmentJourney] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState();

  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");

  const CONSULTATION_TYPE = {
    INCLINIC: "in-clinic",
    INSTANT: "instant",
  };

  const APPOINTMENT_STATUS = {
    CONFIRMED: "confirmed",
    CHECKED_IN: "checked in",
    NO_SHOW: "no show",
    IN_PROGRESS: "in progress",
    CANCEL: "cancelled",
    COMPLETED: "completed",
  };

  const menuOptionsForInclinic = [
    {
      id: 1,
      label: "Call Patient",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.NO_SHOW,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.CANCEL,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        setShowCallPatientModal(true);
        setAnchorEl(null);
      },
    },
    {
      id: 2,
      label: "Mark Check-in",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.NO_SHOW,
      ],
      clickHandler: () => {
        markCheckInApi(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      id: 3,
      label: "Mark No Show",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
      ],
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(appointmentData, setShowMarkNoShowModal);
        } else {
          setShowMarkNoShowModal(true);
        }
        setAnchorEl(null);
      },
    },
    {
      id: 4,
      label: "Raise Invoice",
      appointmentStatus: [
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(appointmentData, setRaiseInvoiceModal);
        } else {
          setRaiseInvoiceModal(true);
        }
        setAnchorEl(null);
      },
    },
    {
      id: 5,
      label: "Reschedule",
      appointmentStatus: [APPOINTMENT_STATUS.CONFIRMED],
      clickHandler: () => {
        // selected_doctor.map((data) => {
        //   if (data.doctor_id === appointmentData?.doctor_id) {
        //     setSlugUrl(data.short_url_slug);
        //   }
        // });

        // send selected_doctor as props or slugurl as props
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(appointmentData, setShowRescheduleModal);
        } else {
          setShowRescheduleModal(true);
        }
        setAnchorEl(null);
      },
    },
    {
      id: 6,
      label: "Cancel",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
      ],
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(appointmentData, setShowCancellationModal);
        } else {
          setShowCancellationModal(true);
        }
        setAnchorEl(null);
      },
    },
    {
      id: 7,
      label: "View Details",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.NO_SHOW,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.CANCEL,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        viewDetailsApi(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      id: 8,
      label: "View Documents",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.NO_SHOW,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.CANCEL,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        setAppointmentForDrawer({
          app_id: { id: appointmentData?.appointment_id },
        });
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(appointmentData, setDrawerOpen);
        } else {
          setDrawerOpen(true);
        }
        setDrawerType(ACTION_TYPES.VIEW_DOCUMENTS);
        setAnchorEl(null);
      },
    },
    {
      id: 9,
      label: "Edit Reciept",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        appointmentData.edit_receipt = true;
        setRaiseInvoiceModal(true);
        setAnchorEl(null);
      },
    },
    {
      id: 10,
      label: "Share Reciept",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        shareReceipt(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      id: 11,
      label: "View Reciept",
      appointmentStatus: [
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        viewReceipt(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      id: 12,
      label: "Start Consultation",
      appointmentStatus: [APPOINTMENT_STATUS.CHECKED_IN],
      clickHandler: () => {
        checkForInProgressAppnt(appointmentData, startConsultationApi);
        setAnchorEl(null);
      },
    },
    {
      id: 13,
      label: "End Consultation",
      appointmentStatus: [
        (user_type === USER_TYPE.DOCTOR ||
          (user_type === USER_TYPE.STAFF &&
            appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC)) &&
          APPOINTMENT_STATUS.IN_PROGRESS,
      ],
      clickHandler: () => {
        endConsultationApi(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      id: 14,
      label:
        user_type === "doctor" ? "Create Prescription" : "Upload Prescription",
      appointmentStatus: [
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        editPrescriptionAction(
          appointmentData,
          user_type === APPLICABLE_ROLE.DOCTOR
            ? ACTION_TYPES.CREATE_PRESCRIPTION
            : ACTION_TYPES.UPLOAD_PRESCRIPTION
        );
        setAnchorEl(null);
      },
    },
    {
      id: 15,
      label:
        user_type === "doctor" ? "Edit Prescription" : "Manage Prescription",
      appointmentStatus: [
        APPOINTMENT_STATUS.IN_PROGRESS,
        APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        editPrescriptionAction(
          appointmentData,
          user_type === APPLICABLE_ROLE.DOCTOR
            ? ACTION_TYPES.EDIT_PRESCRIPTION
            : ACTION_TYPES.MANAGE_PRESCRIPTION
        );
        setAnchorEl(null);
      },
    },
    {
      id: 16,
      label: "View Prescription",
      appointmentStatus: [APPOINTMENT_STATUS.COMPLETED],
      clickHandler: () => {
        // viewPrescription(appointmentData);
        history.push({
          pathname:
            "/clinic/account/mypatients/prescription/" +
            appointmentData.appointment_id,
          state: {
            pageNumber: currentPage,
            appointmentId: appointmentData.appointment_id,
          },
        });
        setAnchorEl(null);
      },
    },
    {
      id: 17,
      label: "Share Patient Education Content",
      appointmentStatus: [
        userId === appointmentData.doctor_id &&
          user_type !== APPLICABLE_ROLE.STAFF &&
          APPOINTMENT_STATUS.COMPLETED,
      ],
      clickHandler: () => {
        setselectedPatientId(appointmentData?.patient_id);
        setshowPEMShare(true);
        setAnchorEl(null);
      },
    },
  ];

  const open = Boolean(anchorEl);

  useEffect(() => {
    let time = moment(
      appointmentData.appointment_date +
        "T" +
        appointmentData.appointment_start_time
    )
      .add(12, "hours")
      .format("MMM DD, YYYY hh:mm A");
    let tooltip = `The Appointment link will be active till ${time}. It will automatically get cancelled and refunded in case consultation does not happen.`;
    setTimeExceededTooltip(tooltip);
  }, [appointmentData]);

  useEffect(() => {
    if (appointmentData !== null && appointmentData.appointment_id !== "") {
      const current = moment();
      const dtAppointment = moment(
        appointmentData.appointment_date +
          "T" +
          appointmentData.appointment_start_time
      );

      let difference = Math.abs(current.diff(dtAppointment, "minutes"));

      if (
        difference < 720 &&
        appointmentData?.appointment_status !== "completed" &&
        !appointmentData?.appointment_status
          ?.toLowerCase()
          .includes("cancelled") &&
        appointmentData.appointment_type === "online"
      ) {
        setShowVideoIcon(true);
      } else {
        setShowVideoIcon(false);
      }
    }
  }, [appointmentData]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCloseAlertPopup = () => {
    setOpenAlert(false);
  };

  const getFilteredMenu = (appointment) => {
    if (appointment.appointment_type === CONSULTATION_TYPE.INCLINIC) {
      const endTime = moment(
        appointment.consultation_end_time
          ? appointment.consultation_end_time
          : appointment.appointment_date +
              " " +
              appointment.appointment_end_time.split("+")[0]
      ).add(48, "hours");
      const endReceiptTime = moment(
        appointment.consultation_end_time
          ? appointment.consultation_end_time
          : appointment.appointment_date +
              " " +
              appointment.appointment_end_time.split("+")[0]
      ).add(12, "hours");
      const endReceiptStatus = moment().isAfter(endReceiptTime); // if it passed
      const editButtonStatus = moment().isAfter(endTime);

      switch (appointment.appointment_status.toLowerCase()) {
        case APPOINTMENT_STATUS.CONFIRMED:
          if (appointment.payment_method === "online") {
            if (appointment.invoice_raised_by !== "") {
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 && option.id !== 9
              );
            }
            if (endReceiptStatus || appointment.receipt_finalized === "True") {
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 9 &&
                  option.id !== 4
              );
            }
          } else {
            if (appointment.invoice_raised_by !== "") {
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 4 &&
                  option.id !== 10 &&
                  option.id !== 11 &&
                  option.id !== 9
              );
            }
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 10 &&
                option.id !== 11 &&
                option.id !== 9
            );
          }

          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 10 &&
              option.id !== 11 &&
              option.id !== 9
          );

        case APPOINTMENT_STATUS.CHECKED_IN:
          if (appointment.invoice_raised_by) {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 4 &&
                option.id !== 1
            );
          }
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 9 &&
              option.id !== 10 &&
              option.id !== 11
          );

        case APPOINTMENT_STATUS.IN_PROGRESS:
          if (appointment.invoice_raised_by) {
            if (endReceiptStatus || appointment.receipt_finalized === "True") {
              if (!editButtonStatus && appointment.prescription_status === "") {
                return menuOptionsForInclinic.filter(
                  (option) =>
                    option.appointmentStatus.indexOf(
                      appointment.appointment_status.toLowerCase()
                    ) !== -1 &&
                    option.id !== 4 &&
                    option.id !== 9 &&
                    option.id !== 15 &&
                    option.id !== 16 &&
                    option.id !== 17
                );
              }
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 4 &&
                  option.id !== 9 &&
                  option.id !== 14 &&
                  option.id !== 16 &&
                  option.id !== 17
              );
            }
            // else {
            // edit receipt ,view receipt,share receipt
            if (!editButtonStatus && appointment.prescription_status === "") {
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 4 &&
                  option.id !== 15 &&
                  option.id !== 16 &&
                  option.id !== 17
              );
            }
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 4 &&
                option.id !== 14 &&
                option.id !== 16 &&
                option.id !== 17
            );
            // }
          }
          // if (!appointment.invoice_raised_by) {
          if (!editButtonStatus && appointment.prescription_status === "") {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 15 &&
                option.id !== 16 &&
                option.id !== 17 &&
                option.id !== 9 &&
                option.id !== 10 &&
                option.id !== 11
            );
          }
          if (!editButtonStatus && appointment.prescription_status !== "") {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16 &&
                option.id !== 17 &&
                option.id !== 9 &&
                option.id !== 10 &&
                option.id !== 11
            );
          }
          // }
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 4 &&
              option.id !== 14 &&
              option.id !== 15 &&
              option.id !== 9
          );

        case APPOINTMENT_STATUS.COMPLETED:
          if (appointment.invoice_raised_by) {
            if (endReceiptStatus || appointment.receipt_finalized === "True") {
              if (!editButtonStatus && appointment.prescription_status === "") {
                return menuOptionsForInclinic.filter(
                  (option) =>
                    option.appointmentStatus.indexOf(
                      appointment.appointment_status.toLowerCase()
                    ) !== -1 &&
                    option.id !== 4 &&
                    option.id !== 9 &&
                    option.id !== 15 &&
                    option.id !== 16
                );
              }
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 4 &&
                  option.id !== 9 &&
                  option.id !== 14 &&
                  option.id !== 16
              );
            }
            // else {
            // edit receipt ,view receipt,share receipt
            if (!editButtonStatus && appointment.prescription_status === "") {
              return menuOptionsForInclinic.filter(
                (option) =>
                  option.appointmentStatus.indexOf(
                    appointment.appointment_status.toLowerCase()
                  ) !== -1 &&
                  option.id !== 4 &&
                  option.id !== 15 &&
                  option.id !== 16
              );
            }
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 4 &&
                option.id !== 14 &&
                option.id !== 16
            );
            // }
          }
          // if (!appointment.invoice_raised_by) {
          if (!editButtonStatus && appointment.prescription_status === "") {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 15 &&
                option.id !== 16 &&
                option.id !== 9 &&
                option.id !== 10 &&
                option.id !== 11
            );
          }
          if (!editButtonStatus && appointment.prescription_status !== "") {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16 &&
                option.id !== 9 &&
                option.id !== 10 &&
                option.id !== 11
            );
          }
          // }
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 4 &&
              option.id !== 14 &&
              option.id !== 15 &&
              option.id !== 9
          );

        case APPOINTMENT_STATUS.NO_SHOW:
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1
          );
        default:
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1
          );
      }
    } else {
      const endTime = moment(
        appointment.consultation_end_time
          ? appointment.consultation_end_time
          : appointment.appointment_date +
              " " +
              appointment.appointment_end_time.split("+")[0]
      ).add(48, "hours");
      const editButtonStatus = moment().isAfter(endTime);
      let opt = [];
      switch (appointment.appointment_status.toLowerCase()) {
        case APPOINTMENT_STATUS.NO_SHOW:
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 1 &&
              option.id !== 2
          );
        case APPOINTMENT_STATUS.IN_PROGRESS:
          opt = menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 1 &&
              option.id !== 4 &&
              option.id !== 9
          );
          if (
            editButtonStatus &&
            (appointment.prescription_notification_sent === "True" ||
              appointment.manual_rx_notification_sent === "True")
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 15
            );
          } else if (
            !editButtonStatus &&
            (appointment.prescription_notification_sent === "True" ||
              appointment.manual_rx_notification_sent === "True")
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16
            );
          } else if (
            !editButtonStatus &&
            appointment.prescription_notification_sent === "False" &&
            appointment.manual_rx_notification_sent === "False" &&
            appointment.prescription_status !== ""
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16
            );
          } else if (
            !editButtonStatus &&
            appointment.prescription_notification_sent === "False" &&
            appointment.manual_rx_notification_sent === "False" &&
            appointment.prescription_status === ""
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 15 &&
                option.id !== 16
            );
          } else {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 15 &&
                option.id !== 16
            );
          }

          return opt;
        case APPOINTMENT_STATUS.CANCEL:
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 1 &&
              option.id !== 2
          );
        case APPOINTMENT_STATUS.CONFIRMED:
          if (
            appointment.consultation_type?.toLowerCase() ===
            CONSULTATION_TYPE.INSTANT
          ) {
            return menuOptionsForInclinic.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 1 &&
                option.id !== 2 &&
                option.id !== 4 &&
                option.id !== 3 &&
                option.id !== 9 &&
                option.id !== 5 &&
                option.id !== 6
            );
          }
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 1 &&
              option.id !== 2 &&
              option.id !== 4 &&
              option.id !== 3 &&
              option.id !== 9
          );
        case APPOINTMENT_STATUS.COMPLETED:
          opt = menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1 &&
              option.id !== 1 &&
              option.id !== 4 &&
              option.id !== 9
          );
          if (
            editButtonStatus &&
            (appointment.prescription_notification_sent === "True" ||
              appointment.manual_rx_notification_sent === "True")
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 15
            );
          } else if (
            !editButtonStatus &&
            (appointment.prescription_notification_sent === "True" ||
              appointment.manual_rx_notification_sent === "True")
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16
            );
          } else if (
            !editButtonStatus &&
            appointment.prescription_notification_sent === "False" &&
            appointment.manual_rx_notification_sent === "False" &&
            appointment.prescription_status !== ""
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 16
            );
          } else if (
            !editButtonStatus &&
            appointment.prescription_notification_sent === "False" &&
            appointment.manual_rx_notification_sent === "False" &&
            appointment.prescription_status === ""
          ) {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 15 &&
                option.id !== 16
            );
          } else {
            opt = opt.filter(
              (option) =>
                option.appointmentStatus.indexOf(
                  appointment.appointment_status.toLowerCase()
                ) !== -1 &&
                option.id !== 14 &&
                option.id !== 15 &&
                option.id !== 16
            );
          }

          return opt;
        default:
          return menuOptionsForInclinic.filter(
            (option) =>
              option.appointmentStatus.indexOf(
                appointment.appointment_status.toLowerCase()
              ) !== -1
          );
      }
    }
  };

  function joinVideoCall() {
    let appointment = appointmentData;
    history.replace(`${location.pathname}`);
    history.push({
      pathname:
        doctorClinicAssociation === "true" ? "/clinic/video" : "doctor/video",
      state: {
        app_id: {
          // this is required as video component requires these properties
          // TODO: to be optimized once video render logic is rewritten
          id: appointment.appointment_id,
          patient_id: appointment.patient_id,
          patient_account_id: appointment.patient_account_id,
          patient_name: appointment.patient_name,
          patient_dob: appointment.patient_dob,
          phone_no: appointment.patient_phone_no,
          patient_city: appointment.patient_city,
          first_name: appointment.first_name,
          last_name: appointment.last_name,
          degree: appointment.degree,
          appointment_date: appointment.appointment_date,
          appointment_end_date_time:
            appointment.appointment_date +
            " " +
            appointment.appointment_end_time,
          appointment_start_date_time: appointment.appointment_date_and_time,
          start_time: appointment.appointment_start_time,
          end_time: appointment.appointment_end_time,
          doctor_id: appointment.doctor_id,
          in_progress:
            appointment?.appointment_status === APPLICABLE_STATUS.IN_PROGRESS
              ? true
              : false,
        },
        is_audio: true,
        is_video: true,
      },
    });
  }

  function handleDrawerToggle() {
    setDrawerOpen(false);
  }

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "",
      fileURL: "",
      fileType: "",
    });
  };

  const pemCloseBtnCallback = (closeBtnState = false) => {
    setshowPEMShare(false);
    if (!closeBtnState) {
      setShowPopUp(true);
    }
  };

  let startTimer = (endTimeValue) => {
    // const endTime = moment(endTimeValue);

    const startTime = moment(endTimeValue);
    const durationInMinutes = "48";
    const initalDateTime = moment(startTime, "YYYY-MM-DD HH:mm:ss")
      .add(durationInMinutes, "hours")
      .format("YYYY-MM-DD HH:mm:ss");

    const finalDateTime = moment(initalDateTime);

    interval = setInterval(() => {
      let distance = finalDateTime.diff(moment());
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };

  // API Calls ==>

  const checkForInProgressAppnt = (appnt, func) => {
    let data = {
      doctor_id: userId,
    };
    let result = c2cPostApiHandler(CHECK_IN_PROGRESS_APPOINTMENT_API, data);
    result.then(([response, error]) => {
      if (!error) {
        if (response.data && response.data.statusCode === 200) {
          // Check for ongoing appointment
          if (
            response.data.ongoing_appointment &&
            response?.data?.data?.appointment_id !== appnt?.appointment_id
          ) {
            response.data.data.consultation_type = getConsultationTypeDetail(
              response.data.data
            );
            setOngoingAppointment(response.data.data);
            setShowCloseOngoingConsultModal(true);
          }
          // Check for upcoming scheduled appointment
          else if (response.data.upcoming_appointment) {
            setScheduledAppointment(response.data.data);
            setShowAppointmentScheduledModal(true);
          } else if (
            clinicId === response?.data?.data?.clinic_id &&
            response?.data?.data?.appointment_id !== appnt?.appointment_id
          ) {
            setOngoingAppointment(response.data.data);
            setShowCloseOngoingConsultModal(true);
          } else {
            func(appnt);
          }
        }
      }
    });
  };

  const markCheckInApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staffId : userId,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };
    let result = c2cPostApiHandler(MARK_CHECK_IN_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setOpenAlert(true);
          setAlertMsg("Mark Checked In Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            refreshAppointments(); //api call
          }, 2000);
        }
      }
    });
  };

  const startConsultationApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staffId : userId,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };
    let result = c2cPostApiHandler(START_CONSULTATION_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setOpenAlert(true);
          setAlertMsg("Consultation Started Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            refreshAppointments(); //api call
          }, 2000);
        }
      }
    });
  };

  const endConsultationApi = (appnt) => {
    let data = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staffId : userId,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
    };
    let result = c2cPostApiHandler(END_CONSULTATION_API, data);
    result.then(([res, error]) => {
      if (!error) {
        if (
          res?.data &&
          res?.data?.message === "Appointment status updated successfully!"
        ) {
          setOpenAlert(true);
          setAlertMsg("Consultation Ended Successfully");
          setTimeout(() => {
            handleCloseAlertPopup();
            refreshAppointments(); //api call
          }, 2000);
        }
      }
    });
  };

  const viewDetailsApi = (appnt) => {
    setShowViewModal(true);
    let data = {
      appointment_id: appnt.appointment_id,
    };
    let details = c2cPostApiHandler(GET_APPOINTMENT_JOURNEY_API, data);
    details.then(([res, error]) => {
      if (!error) {
        if (res?.data) {
          setAppointmentJourney(res.data);
        }
      }
    });
  };

  const checkAppointmentStatusApi = (appnt, func) => {
    let data = {
      appointment_id: appnt.appointment_id,
    };
    let statusData = c2cPostApiHandler(CHECK_NO_SHOW_STATUS_API, data);
    statusData.then(([res, error]) => {
      if (!error) {
        if (res && data.appointment_id === res.data?.data?.appointment_id) {
          if (res.data?.data?.no_show === "False") {
            func(true);
          } else {
            setShowMessage(true);
            setMessage("This appointment is marked as No Show");
            setTimeout(() => {
              setShowMessage(false);
              // refreshAppointments(); //api call
            }, 1500);
          }
        }
      }
    });
  };

  const shareReceipt = (appnt) => {
    let payload = {
      doctor_id: appnt.doctor_id ? appnt.doctor_id : userId,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      staff_id: staffId,
    };
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenId,
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setshowReceiptModal(true);
          setTimeout(function () {
            setshowReceiptModal(false);
            window.location.reload();
          }, 2000);
        }
      })
      .catch((err) =>
        C2CConsole.log("error in share api/v1/doctor/share-receipt", err)
      );
  };

  const viewReceipt = (appnt) => {
    let payload = {
      doctor_id: appnt.doctor_id ? appnt.doctor_id : userId,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      staff_id: staffId,
      is_shared: "False",
    };
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenId,
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setFileDetails((prev) => ({
            ...prev,
            fileURL: response?.data?.invoice_link,
          }));
          if (response?.data?.invoice_link !== "") {
            setDocumentShow(true);
          } else {
            swal({
              title: "Unable to generate receipt.",
              text: "Please try again",
              icon: "error",
              button: "Okay",
            });
            setDocumentShow(false);
          }
        } else {
          swal({
            title: "Unable to generate receipt.",
            text: "Please try again",
            icon: "error",
            button: "Okay",
          });
          setDocumentShow(false);
        }
      })
      .catch((err) => {
        setDocumentShow(false);
        C2CConsole.log("error in view api/v1/doctor/share-receipt", err);
      });
  };

  // <===

  const mob_options = getAppointmentOptions({
    appointmentData,
    markNoShowAction,
    rescheduleAppointmentAction,
    raiseInvoiceAction,
    handleViewDocumentClick,
    setAnchorEl,
    showVideoIcon,
    handleJoinCallClick,
    viewAppointment,
    cancelAppointmentAction,
    startTimer,
    editPrescriptionAction,
    setShowCallPatientModal,
    timerHours,
    timerMinutes,
    timerSeconds,
  });

  const getTitleStyle = (appnt) => {
    let style = {};
    STATUS.forEach((st) => {
      if (st.name === appnt.appointment_status.toLowerCase()) {
        style = {
          color: st.color,
          backgroundColor: st.backgroundColor,
          border: "1px solid " + st.color,
        };
      }
    });
    return style;
  };
  // navigation logic =>

  const viewPrescription = (appointment) => {
    if (
      appointment.prescription_notification_sent === "True" &&
      appointment?.manual_rx_notification_sent === "True"
    ) {
      return (
        <IconButton
          className={classes.padding}
          aria-label="View Prescription"
          data-tooltip="View Prescription"
          data-tooltip-conf="bottom"
        >
          <Link
            to={{
              pathname:
                "/doctor/account/mypatients/prescription/" +
                appointment.appointment_id,
              state: {
                pageNumber: currentPage,
                appointmentId: appointment.appointment_id,
              },
            }}
          >
            <img
              src={ViewPrescriptionIcon}
              alt="View Prescription"
              style={{ width: 18 }}
            />
          </Link>
        </IconButton>
      );
    }
    return null;
  };

  const editPrescription = (appointment) => {
    // if (appointment?.prescription_notification_sent) {
    //   if (appointment?.prescription_notification_sent === "False" || appointment?.manual_rx_notification_sent === "False") {
    const endTime = moment(
      appointment.consultation_end_time
        ? appointment.consultation_end_time
        : appointment.appointment_date +
            " " +
            appointment.appointment_end_time.split("+")[0]
    ).add(48, "hours");
    const editButtonStatus = moment().isAfter(endTime); // true
    let is_allow = localStorage.getItem("edit_prescriptions_allow");
    if (editButtonStatus) {
      // return null;
      if (
        appointment.prescription_notification_sent === "True" ||
        appointment.manual_rx_notification_sent === "True"
      ) {
        return (
          <IconButton
            className={classes.padding}
            aria-label="View Prescription"
            data-tooltip="View Prescription"
            data-tooltip-conf="bottom"
          >
            <Link
              to={{
                pathname:
                  "/doctor/account/appointmenthistory/prescription/" +
                  appointment.appointment_id,
                state: {
                  pageNumber: currentPage,
                },
              }}
            >
              <img
                src={ViewPrescriptionIcon}
                alt="View Prescription"
                style={{ width: 18 }}
              />
            </Link>
          </IconButton>
        );
      }
    } else {
      startTimer(
        appointment.consultation_end_time
          ? appointment.consultation_end_time
          : appointment.appointment_date +
              " " +
              appointment.appointment_end_time.split("+")[0]
      );
      clearStorage.clearPatientData();
      return (
        <>
          <IconButton
            className={classes.padding}
            aria-label="Edit Prescription"
            onClick={() => editPrescriptionAction(appointment)}
            data-tooltip="Edit Prescription"
            data-tooltip-conf="bottom"
            disabled={user_type === "doctor" ? false : !is_allow}
          >
            <img
              src={EditPrescriptionIcon}
              alt="Edit Prescription"
              style={{ width: 18 }}
            />
          </IconButton>
          {user_type === "doctor" || user_type === "staff" ? (
            <small
              className="cursor-pointer textLink text-center"
              style={{
                color: "#DA1346",
                fontSize: 10,
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {(appointment.consultation_end_time
                ? appointment.consultation_end_time
                : appointment.appointment_date +
                  " " +
                  appointment.appointment_end_time.split("+")[0]) && (
                <>
                  Expires in
                  <span>
                    {timerHours}:
                    {timerMinutes < 10 ? `0${timerMinutes}` : timerMinutes}:
                    {timerSeconds < 10 ? `0${timerSeconds}` : timerSeconds}
                  </span>
                </>
              )}
            </small>
          ) : null}
        </>
      );
    }
    //   }
    // }
    // return null;
  };
  function getActionSheet(appointment) {
    //return multiple icons / actions from in here\
    return (
      <>
        <IconButton
          className={classes.padding}
          aria-label="View Documents"
          onClick={() =>
            appointment.has_document === "True"
              ? handleViewDocumentClick(appointment)
              : ""
          }
          data-tooltip={
            appointment.has_document === "True" ? "View Documents" : null
          }
          data-tooltip-conf="bottom"
        >
          {appointment?.has_document === "True" &&
          appointment?.appointment_status != "No show" ? (
            <img
              src={ViewDocumentIcon}
              alt="View Document"
              style={{ width: 18 }}
            />
          ) : (
            <img src={NotAvailble} alt="No Document" style={{ width: 18 }} />
          )}
        </IconButton>
        <IconButton
          className={classes.padding}
          aria-label="View Details"
          onClick={() => {
            viewDetailsApi(appointmentData);
            // navigate to viewAppointment
          }}
          data-tooltip="View Details"
          data-tooltip-conf="bottom"
        >
          <img src={UserDetailIcon} alt="View Details" style={{ width: 18 }} />
        </IconButton>
        {appointment?.appointment_status != "No show" &&
          appointment?.appointment_status === "completed" &&
          editPrescription(appointment)}
        {appointment?.appointment_status != "No show" &&
        appointment?.appointment_status !== "completed" &&
        !appointmentData?.appointment_status
          ?.toLowerCase()
          .includes("cancelled") &&
        (appointmentData?.appointment_status?.includes("reschedule") ||
          appointmentData?.appointment_status?.includes("upcoming") ||
          appointmentData?.appointment_status?.includes("in progress") ||
          appointmentData?.appointment_status?.includes("confirmed")) &&
        appointmentData?.appointment_type === "online" &&
        showVideoIcon ? (
          <>
            {user_type != "staff" ? (
              <IconButton
                className={classes.padding}
                aria-label="join-call"
                onClick={() => handleJoinCallClick(appointment)}
                data-tooltip="Join Call"
                data-tooltip-conf="bottom"
              >
                <img src={VideoIcon} alt="Start Video" style={{ width: 18 }} />
              </IconButton>
            ) : (
              <IconButton
                className={classes.disableWithPadding}
                aria-label="join-call"
                data-tooltip="Join Call"
                data-tooltip-conf="bottom"
              >
                <img src={VideoIcon} alt="Start Video" style={{ width: 18 }} />
              </IconButton>
            )}
          </>
        ) : (
          ""
        )}

        <div>
          <IconButton
            className={classes.padding}
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleMenuClick}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu
            id="long-menu"
            open={open}
            anchorEl={anchorEl}
            keepMounted
            onClose={handleMenuClose}
          >
            {getFilteredMenu(appointment).map((option, index) => (
              <MenuItem key={index}>
                <div
                  onClick={() => {
                    option.clickHandler(appointment);
                  }}
                >
                  <span className="pl-2">{option.label}</span>
                </div>
              </MenuItem>
            ))}
          </Menu>
        </div>
        <CallModal
          openView={showCallPatientModal}
          closeView={() => {
            setShowCallPatientModal(false);
          }}
          modalCloseView={() => {
            setShowCallPatientModal(false);
          }}
          appointment_id={appointmentData.appointment_id}
          patientName={appointmentData.patient_name}
        />
      </>
    );
  }
  const renderAppointment = (appointmentData) => {
    return (
      <div className="appointment-table-row-status">
        <TitleSubtitleCard
          titleStyle={getTitleStyle(appointmentData)}
          title={appointmentData?.appointment_status}
          subtitle={
            appointmentData?.payment_method.toLowerCase() === "online"
              ? "Paid Online"
              : appointmentData?.payment_method
          }
        />
      </div>
    );
  };

  const cellElementUI = (title, subtitle) => {
    return (
      <div className="created_at">
        {title ? (
          <>
            <p className="m-0">{title}</p>
            <>
              {subtitle && (
                <p className="m-0">
                  <small>{subtitle}</small>
                </p>
              )}
            </>
          </>
        ) : (
          <p className="m-0 text-label ">-</p>
        )}
      </div>
    );
  };

  const displayModals = () => {
    return (
      <>
        <CallModal
          openView={showCallPatientModal}
          closeView={() => {
            setShowCallPatientModal(false);
          }}
          modalCloseView={() => {
            setShowCallPatientModal(false);
          }}
          appointment_id={appointmentData?.appointment_id}
          patientName={appointmentData?.patient_name}
        />
        <AppointmentJoinModal
          appointment={appointmentData}
          doctor_id={appointmentData?.doctor_id}
          openView={showJoinAppointmentModal}
          closeView={() => {
            setShowJoinAppointmentModal(false);
          }}
          joinVideoCallback={joinVideoCall}
        />
        <RescheduleModal
          appointment={appointmentData}
          doctor_id={appointmentData?.doctor_id}
          openView={showRescheduleModal}
          closeView={() => {
            setShowRescheduleModal(false);
          }}
          slugUrl={slugUrl}
          refreshAppointmentsMethod={refreshAppointments} //api call
        />
        <CancellationModal
          appointment_id={appointmentData?.appointment_id}
          doctorId={appointmentData?.doctor_id}
          openView={showCancellationModal}
          closeView={() => {
            setShowCancellationModal(false);
          }}
          refreshAppointmentsMethod={refreshAppointments} //api call
        />
        <MarkCheckInModal
          appointment_id={appointmentData?.appointment_id}
          edit_receipt={appointmentData?.edit_receipt}
          openView={showRaiseInvoiceModal}
          closeView={() => {
            setRaiseInvoiceModal(false);
          }}
          refreshAppointmentsMethod={refreshAppointments} //api call
          doctor_id={appointmentData?.doctor_id}
        />
        <MarkNoShowModal
          appointment_id={appointmentData?.appointment_id}
          openView={showMarkNoShowModal}
          closeView={() => {
            setShowMarkNoShowModal(false);
          }}
          refreshAppointmentsMethod={refreshAppointments} //api call
          doctor_id={appointmentData?.doctor_id}
        />
        <CloseOngoingAppntModal
          appointment_id={ongoingAppointment?.appointment_id}
          patient_name={ongoingAppointment?.patient_name}
          consultation={ongoingAppointment?.consultation_type}
          ongoingAppointment={ongoingAppointment}
          openView={showCloseOngoingConsultModal}
          closeView={() => {
            setShowCloseOngoingConsultModal(false);
          }}
          joinVideoCallback={joinVideoCall}
          endConsultationApi={endConsultationApi}
          startConsultationApi={startConsultationApi}
          currentAppointment={appointmentData}
        />

        <ScheduledAppntModal
          appointment_id={scheduledAppointment.appointment_id}
          patient_name={scheduledAppointment.patient_name}
          appointment_start_time={scheduledAppointment.appointment_start_time}
          appointment_end_time={scheduledAppointment.appointment_end_time}
          currentAppointment={appointmentData}
          openView={showAppointmentScheduledModal}
          closeView={() => {
            setShowAppointmentScheduledModal(false);
          }}
          refreshAppointmentsMethod={refreshAppointments}
          joinVideoCallback={joinVideoCall}
          startConsultationApi={startConsultationApi}
        />
        <ClinicDrawerComponent
          drawerOpen={drawerOpen}
          toggleDrawer={handleDrawerToggle}
          drawerType={drawerType}
          appointmentForDrawer={appointmentForDrawer}
          // fetchPastAppointmentDataList={refreshAppointments} api call
        />
        <ViewDetailsModalNew
          openView={showViewModal}
          closeView={() => {
            setShowViewModal(false);
          }}
          appointmentJourney={appointmentJourney}
          appointment_id={appointmentData?.appointment_id}
          appointment_status={appointmentData?.appointment_status}
        />
        {documentShow && (
          <DocumentContainer
            cancelHandler={() => closeNotification()}
            url={fileDetails.fileURL}
            fileName={fileDetails.fileName}
            fileType={fileDetails.fileType}
            width={"98%"}
          />
        )}
        <ClinicShareReceiptModal show={showReceiptModal} />
        {showPEMShare && (
          <PEMShareContentPopUp
            patientId={selectedPatientId}
            appointment_id={appointmentData?.appointment_id}
            isERx={appointmentData?.prescription_notification_sent}
            pemCloseBtnCallback={pemCloseBtnCallback}
          />
        )}
        <Popup
          title={"Patient Education Content Shared!"}
          show={showPopUp}
          handleClose={() => setShowPopUp(false)}
        />
        {openAlert && <AlertMsgPopup alertMsg={alertMsg} />}
      </>
    );
  };

  return (
    <div>
      <div
        className="mx-2 py-3 mb-2  row appointment-row align-items-center shadow-sm rounded-sm d-none d-lg-flex"
        key={appointmentData?.appointment_number}
        style={{ border: "1px solid #E6E6E6" }}
      >
        {/* new  */}
        {cellElementUI(
          appointmentData.appointment_date &&
            moment(appointmentData.appointment_date).format("MMM DD, YYYY"),
          moment(appointmentData?.appointment_start_time, "hh:mm:ssZ").format(
            "hh:mm A"
          )
        )}
        {cellElementUI(appointmentData?.doctor_name)}
        {/* {cellElementUI(appointmentData?.doctor_name)} */}
        {cellElementUI(
          appointmentData.checked_in_time &&
            moment(appointmentData.checked_in_time).format(
              "MMM DD, YYYY, hh:mm A"
            ),
          appointmentData?.checked_in_by
        )}
        {cellElementUI(
          appointmentData.consultation_start_time &&
            moment(appointmentData.consultation_start_time).format(
              "MMM DD, YYYY, hh:mm A"
            ),
          appointmentData?.consultation_started_by
        )}
        {cellElementUI(
          appointmentData.consultation_end_time &&
            moment(appointmentData.consultation_end_time).format(
              "MMM DD, YYYY, hh:mm A"
            ),
          appointmentData?.consultation_ended_by
        )}

        {/*  */}
        <div className="consultation_type">
          {appointmentData?.consultation_type !== "instant" ? (
            <>
              <p className="m-0 text-label ">
                {renderAppointmentType(appointmentData?.appointment_type)}
              </p>
              <p className="m-0 text-label ">
                <small>
                  {renderConsultationType(
                    appointmentData?.appointment_type,
                    appointmentData?.consultation_type,
                    appointmentData?.procedure_name
                  )}
                </small>
              </p>
            </>
          ) : (
            <p className="m-0 text-label ">
              {renderConsultationType(appointmentData?.consultation_type)}
            </p>
          )}
        </div>
        <div className="appointment_status">
          {renderAppointment(appointmentData)}
        </div>
        {/* changes for 12950 ==> */}
        {/* <div className="paid_amount d-flex align-items-center action-button">
          {getActionSheet(appointmentData)}
        </div> */}
        {/* <== changes for 12950 */}
      </div>

      {/* Mobile section */}
      <div
        className="row appointment-row py-2 mb-2 shadow-sm rounded-sm d-xs d-sm d-md d-lg-none d-xl-none appointment_row_card bg-white-card"
        key={appointmentData.appointment_start_time}
      >
        <div className="col-12">
          <div className="row">
            <div className="col-6">
              <p className="header m-0 mb-1">Appointment Date &amp; Time</p>
              <p className="m-0">
                {moment(appointmentData.appointment_date).format(
                  "MMM DD, YYYY"
                )}
              </p>
              <p className="m-0">
                <small>
                  {moment(
                    appointmentData.appointment_start_time,
                    "hh:mm:ssZ"
                  ).format("hh:mm A")}
                </small>
              </p>
              {moment() >
                moment(
                  `${appointmentData.appointment_date} ${appointmentData.appointment_end_time}`
                ) &&
              appointmentData.appointment_type === "online" &&
              (appointmentData.appointment_status.includes("reschedule") ||
                appointmentData.appointment_status.toLowerCase() ==
                  "upcoming") ? (
                <p className="m-0 text-danger">
                  <small
                    data-tooltip={timeExceededTooltip}
                    data-tooltip-conf="multiline bottom"
                  >
                    Time exceeded &nbsp;
                    <i className="fa fa-info-circle"></i>
                  </small>
                </p>
              ) : (
                ""
              )}
              {moment() >
                moment(
                  `${appointmentData.appointment_date} ${appointmentData.appointment_start_time}`
                ) &&
              appointmentData.appointment_type === "in-clinic" &&
              (appointmentData.appointment_status.includes("reschedule") ||
                appointmentData.appointment_status.toLowerCase() ==
                  "upcoming") ? (
                <p className="m-0 text-danger">
                  <small
                    data-tooltip="Please raise an invoice if the consultation has happened successfully or mark no show"
                    data-tooltip-conf="multiline bottom"
                  >
                    Time exceeded &nbsp;
                    <i className="fa fa-info-circle"></i>
                  </small>
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="col-6">
              <p className="header m-0 mb-1">Mark Check-IN Date &amp; Time</p>
              <p className="m-0">
                {appointmentData?.mark_check_in_time !== ""
                  ? moment(appointmentData?.mark_check_in_time).format(
                      "MMM DD, YYYY"
                    )
                  : "-"}
              </p>
              <p className="m-0">
                <small>
                  {appointmentData?.mark_check_in_time !== "" &&
                    moment(appointmentData?.mark_check_in_time).format(
                      "hh:mm A"
                    )}
                </small>
              </p>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <p className="header m-0 mb-1">Mark Check-IN By </p>
              {appointmentData?.mark_check_in_time ? (
                <>
                  <p className="m-0 text-label ">
                    {appointmentData?.mark_check_in_by}
                  </p>
                  <p className="m-0 text-label ">
                    <small>{appointmentData?.doctor_name}</small>
                  </p>
                </>
              ) : (
                "-"
              )}
            </div>
            <div className="col-6">
              <p className="header m-0 mb-1">Appointment Status</p>
              {renderAppointment(appointmentData)}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <p className="header m-0 mb-1">Consultation</p>
              <p className="m-0 text-label ">
                {renderAppointmentType(appointmentData?.appointment_type)}
              </p>
              <p className="m-0 consultation-label">
                {renderConsultationType(
                  appointmentData.appointment_type,
                  appointmentData.consultation_type,
                  appointmentData.procedure_name
                )}
              </p>
            </div>
          </div>
          {/* <== commented for 12950 */}
        </div>
      </div>
      {displayModals()}
    </div>
  );
}
